import { cva } from 'class-variance-authority';

export const cardStyles = cva(
  ['rounded-lg', 'p-6', 'flex', 'flex-col', 'w-full', 'min-w-0', 'min-h-[218px]', 'border', 'max-w-[352px]'],
  {
    variants: {
      variant: {
        default: ['bg-blue-100', 'border-blue-350', 'gap-[44px]'],
        addNew: ['bg-grey-300', 'border-neutral-400', 'gap-[44px]'],
        error: ['bg-red-500/4', 'border-red-500', 'gap-6'],
        expired: ['bg-red-500/4', 'border-red-500', 'gap-6'],
      },
      showDetails: {
        true: [],
        false: [],
      },
    },
    defaultVariants: {
      variant: 'default',
      showDetails: false,
    },
  }
);
